import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  };

  return (
    <footer style={{ background: '#0f172a', color: '#cbd5e1', marginTop: 'auto' }}>
      {/* Upper Trust Strip */}
      <div 
        style={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
          background: 'rgba(255, 255, 255, 0.02)',
          padding: '24px 20px',
        }}
      >
        <div 
          style={{
            maxWidth: 1280,
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 16,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 24 }}>✨</span>
            <div>
              <strong style={{ color: '#fff', fontSize: 14, display: 'block' }}>100% Genuine Sivakasi Fireworks</strong>
              <span style={{ fontSize: 12, color: '#94a3b8' }}>Certified standard formulations and quality checked</span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 24 }}>🛡️</span>
            <div>
              <strong style={{ color: '#fff', fontSize: 14, display: 'block' }}>100% Legal Compliance</strong>
              <span style={{ fontSize: 12, color: '#94a3b8' }}>Licensed store adhering to Explosives Act</span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 24 }}>💬</span>
            <div>
              <strong style={{ color: '#fff', fontSize: 14, display: 'block' }}>Direct WhatsApp Ordering</strong>
              <span style={{ fontSize: 12, color: '#94a3b8' }}>Fast quotation & booking on +91 79906 96364</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Links */}
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '40px 20px 24px' }}>
        <div 
          style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', 
            gap: 32,
            marginBottom: 36,
          }}
        >
          {/* Brand Col */}
          <div>
            <div 
              style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, cursor: 'pointer' }}
              onClick={() => handleNavigation('/')}
              role="button"
              tabIndex={0}
            >
              <span style={{ fontSize: 22 }}>🧨</span>
              <div>
                <div style={{ fontWeight: 800, color: '#fff', fontSize: 16 }}>જય ભવાની ફટાકડા સ્ટોર</div>
                <div style={{ fontSize: 11, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Jai Bhavani Fatakada Store</div>
              </div>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.6, color: '#94a3b8', margin: '0 0 16px' }}>
              Jay Bhavani Fatakda (Jai Bhavani Fireworks / જય ભવાની ફટાકડા સ્ટોર) – Your trusted online store for wholesale firecrackers, Sivakasi fatakda, sparklers, flowerpots, rockets, sky shots, and Diwali crackers at factory rates.
            </p>
            <a
              href="https://wa.me/917990696364"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: '#16a34a',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: 999,
                fontSize: 13,
                fontWeight: 700,
                textDecoration: 'none',
              }}
            >
              💬 Order on WhatsApp
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <div style={{ fontWeight: 700, marginBottom: 14, color: '#fff', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Quick Navigation
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
              <li>
                <button 
                  onClick={() => handleNavigation('/')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}
                >
                  All Categories
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/my-orders')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}
                >
                  My Orders
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/cart')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}
                >
                  Shopping Cart
                </button>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <div style={{ fontWeight: 700, marginBottom: 14, color: '#fff', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Popular Collections
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13, color: '#94a3b8' }}>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit', textAlign: 'left' }}
                >
                  Sparklers & Ground Chakkars
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit', textAlign: 'left' }}
                >
                  Color Flowerpots (Anar)
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit', textAlign: 'left' }}
                >
                  Multi-Sky Aerial Cakes
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit', textAlign: 'left' }}
                >
                  Sound Bombs & Garlands
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/category')} 
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0, fontSize: 'inherit', textAlign: 'left' }}
                >
                  Family Festival Combo Packs
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div>
            <div style={{ fontWeight: 700, marginBottom: 14, color: '#fff', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Support & Inquiries
            </div>
            <div style={{ fontSize: 13, lineHeight: 1.6, color: '#94a3b8', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <strong style={{ color: '#fff', display: 'block' }}>Direct Helpline:</strong>
                <span>+91 79906 96364</span>
              </div>
              <div>
                <strong style={{ color: '#fff', display: 'block' }}>Operating Hours:</strong>
                <span>9:00 AM – 10:00 PM (Mon – Sun)</span>
              </div>
              <div>
                <strong style={{ color: '#fff', display: 'block' }}>Accepted Payments:</strong>
                <span>UPI, Google Pay, PhonePe, Net Banking</span>
              </div>
            </div>
          </div>
        </div>

        {/* Statutory Compliance & Legal Disclaimer (Supreme Court 2018 Order) */}
        <div 
          style={{ 
            background: 'rgba(239, 68, 68, 0.08)',
            border: '1px solid rgba(239, 68, 68, 0.25)',
            borderLeft: '4px solid #ef4444',
            borderRadius: 10,
            padding: '16px 20px',
            marginBottom: 24,
            fontSize: 12.5,
            lineHeight: 1.65,
            color: '#e2e8f0',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <span style={{ fontSize: 16 }}>⚖️</span>
            <strong style={{ color: '#fca5a5', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Statutory Compliance &amp; Legal Disclaimer (Supreme Court Order 2018)
            </strong>
          </div>
          <p style={{ margin: '0 0 8px 0', color: '#cbd5e1' }}>
            As per the 2018 Supreme Court order, online sale of firecrackers is strictly not permitted! We value our customers and at the same time, respect jurisdiction. This website operates strictly for offline booking, price quotation, and product catalogue display purposes (Jai Bhavani Fireworks).
          </p>
          <p style={{ margin: 0, color: '#94a3b8' }}>
            We request you to add your products to the cart and submit your requirements through the enquiry button. We will contact you within 2-3 hours and confirm the order through WhatsApp or phone call (+91 79906 96364). Jai Bhavani Fireworks follows 100% legal &amp; statutory compliances and all our shops and go-downs are maintained strictly as per the Explosives Act.
          </p>
        </div>

        {/* SEO Keywords Discovery Strip */}
        <div 
          style={{ 
            borderTop: '1px solid rgba(255,255,255,0.08)', 
            paddingTop: 18, 
            marginBottom: 20, 
            fontSize: 11, 
            color: '#64748b', 
            lineHeight: 1.8 
          }}
        >
          <strong style={{ color: '#94a3b8', display: 'block', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Popular Searches:
          </strong>
          <span>
            Jay Bhavani Fatakda • Jaibhavani Store • Jaybhavani Fireworks • Jai Bhavani Firecrackers • Fatakda Online Shopping • Sivakasi Fatakda Wholesale • Buy Firecrackers Online • Diwali Fatakda Store Gujarat • Green Crackers Online • Rockets • Sky Shots • Sound Crackers • Flower Pots • Ground Chakkers • જય ભવાની ફટાકડા સ્ટોર
          </span>
        </div>

        {/* Bottom Bar */}
        <div 
          style={{ 
            borderTop: '1px solid rgba(255,255,255,0.08)', 
            paddingTop: 20, 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            flexWrap: 'wrap', 
            gap: 12,
            fontSize: 12, 
            color: '#64748b' 
          }}
        >
          <div>
            © {new Date().getFullYear()} જય ભવાની ફટાકડા સ્ટોર (Jai Bhavani Fireworks). All rights reserved.
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <span>Green Crackers Certified</span>
            <span>•</span>
            <span>Direct Wholesale Supply</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
